import { lazy } from 'react'

export const SubscriptionsGoogleVariant4 = lazy(
  () => import('./SubscriptionsGoogleVariant4'),
)
